import React, { useState } from "react";
import { toast } from "sonner";
import { Loader2, X, Upload, Link2 } from "lucide-react";
import api, { formatApiErrorDetail } from "../../lib/api";

export const TIPOS = [["video", "Vídeo"], ["tutorial", "Tutorial"], ["manual", "Manual"], ["otros", "Otros"]];
const PARTE = 5 * 1024 * 1024;

async function subirFichero(id, file, onPct) {
  const n = Math.ceil(file.size / PARTE);
  for (let i = 0; i < n; i++) {
    const trozo = file.slice(i * PARTE, (i + 1) * PARTE);
    await api.put(`/descargas/${id}/parte/${i}`, trozo, { headers: { "Content-Type": "application/octet-stream" } });
    onPct(Math.round(((i + 1) / n) * 100));
  }
  await api.post(`/descargas/${id}/completar`);
}

export function FormRecurso({ inicial, onClose, onSaved }) {
  const editando = !!inicial;
  const [f, setF] = useState({ titulo: inicial?.titulo || "", descripcion: inicial?.descripcion || "", tipo: inicial?.tipo || "manual",
                               destacado: inicial?.destacado || "ninguno", modo: "fichero", url: "" });
  const [file, setFile] = useState(null);
  const [pct, setPct] = useState(null);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const guardar = async (e) => {
    e.preventDefault();
    try {
      const base = { titulo: f.titulo, descripcion: f.descripcion || null, tipo: f.tipo };
      if (editando) {
        await api.patch(`/descargas/${inicial.id}`, { ...base, destacado: f.destacado });
      } else {
        if (f.modo === "fichero" && !file) { toast.error("Elige un fichero"); return; }
        const destacado = f.destacado === "ninguno" ? null : f.destacado;
        const body = f.modo === "enlace" ? { ...base, destacado, url: f.url.trim() }
          : { ...base, destacado, filename: file.name, size: file.size, content_type: file.type || "application/octet-stream" };
        const { data } = await api.post("/descargas", body);
        if (f.modo === "fichero") { setPct(0); await subirFichero(data.id, file, setPct); }
      }
      toast.success(editando ? "Recurso actualizado" : "Recurso añadido");
      onSaved();
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "No se pudo guardar");
      setPct(null);
    }
  };

  return (
    <div className="fixed inset-0 z-[80] bg-slate-900/50 flex items-center justify-center p-4" data-testid="recurso-form-modal">
      <form onSubmit={guardar} className="card bg-white p-6 w-full max-w-lg space-y-3">
        <div className="flex items-center justify-between">
          <h3 className="font-display text-xl font-bold">{editando ? "Editar recurso" : "Añadir recurso"}</h3>
          <button type="button" onClick={onClose} disabled={pct != null} data-testid="recurso-form-cerrar"><X size={18} /></button>
        </div>
        <input className="input w-full" placeholder="Título" value={f.titulo} onChange={set("titulo")} required data-testid="recurso-titulo" />
        <textarea className="input w-full min-h-[70px]" placeholder="Descripción (opcional)" value={f.descripcion} onChange={set("descripcion")} data-testid="recurso-descripcion" />
        <div className="grid grid-cols-2 gap-3">
          <select className="input" value={f.tipo} onChange={set("tipo")} data-testid="recurso-tipo">{TIPOS.map(([k, l]) => <option key={k} value={k}>{l}</option>)}</select>
          <select className="input" value={f.destacado} onChange={set("destacado")} data-testid="recurso-destacado">
            <option value="ninguno">Sin destacar</option><option value="recomendado">Recomendado (arriba)</option><option value="novedades">Novedades</option>
          </select>
        </div>
        {!editando && (
          <>
            <div className="inline-flex rounded-lg border border-slate-200 p-0.5">
              {[["fichero", "Subir fichero", Upload], ["enlace", "Enlace YouTube / Vimeo / web", Link2]].map(([k, l, I]) => (
                <button type="button" key={k} onClick={() => setF({ ...f, modo: k })} data-testid={`recurso-modo-${k}`}
                        className={"px-3 py-1.5 text-xs font-semibold rounded-md inline-flex items-center gap-1 " + (f.modo === k ? "bg-slate-900 text-white" : "text-slate-600")}><I size={12} />{l}</button>
              ))}
            </div>
            {f.modo === "fichero"
              ? <input type="file" accept=".pdf,video/*,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.zip" onChange={(e) => setFile(e.target.files[0] || null)} className="block text-sm" data-testid="recurso-fichero" />
              : <input className="input w-full" placeholder="https://www.youtube.com/watch?v=…" value={f.url} onChange={set("url")} required data-testid="recurso-url" />}
          </>
        )}
        {pct != null && (
          <div data-testid="recurso-progreso">
            <div className="h-2 rounded-full bg-slate-100 overflow-hidden"><div className="h-full bg-emerald-500 transition-[width]" style={{ width: `${pct}%` }} /></div>
            <div className="text-xs text-slate-500 mt-1">Subiendo… {pct} %</div>
          </div>
        )}
        <button className="btn btn-primary w-full" disabled={pct != null} data-testid="recurso-guardar">
          {pct != null ? <Loader2 size={14} className="animate-spin" /> : null} {editando ? "Guardar cambios" : "Añadir"}
        </button>
      </form>
    </div>
  );
}
